import { render, staticRenderFns } from "./Popconfirm.vue?vue&type=template&id=d639807c&scoped=true"
import script from "./Popconfirm.vue?vue&type=script&lang=js"
export * from "./Popconfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d639807c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d639807c')) {
      api.createRecord('d639807c', component.options)
    } else {
      api.reload('d639807c', component.options)
    }
    module.hot.accept("./Popconfirm.vue?vue&type=template&id=d639807c&scoped=true", function () {
      api.rerender('d639807c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugin/Popconfirm.vue"
export default component.exports